"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logout_Link = void 0;

Logout_Link = function Logout_Link(selector) {
    (0, _jquery2.default)(document).on("click", selector, function (e) {
        var logoutForm = void 0;
        var next = void 0;
        e.preventDefault();
        logoutForm = (0, _jquery2.default)("#logout-form");
        next = (0, _jquery2.default)(this).data("next");
        if (next) {
            logoutForm.attr("action", logoutForm.attr("action") + "?next=" + next);
        }
        return logoutForm.submit();
    });
};

exports.default = Logout_Link("#user-logout");